/**
 * Thin, safe wrappers around the Meta Pixel (loaded in public/index.html).
 * No-op if the pixel hasn't loaded (e.g. ad-blocker, SSR). Fire only on
 * CONFIRMED success so events reflect real conversions, not attempts.
 */
export function trackPixel(event, params) {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', event, params || undefined);
  }
}

// For platform-specific events that aren't a Meta standard event.
export function trackPixelCustom(event, params) {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('trackCustom', event, params || undefined);
  }
}
